import React from 'react';

import _ from '@ihme/common/locale';

import ChartDropdown from '../ChartDropdown';

type Props = React.ComponentProps<typeof ChartDropdown> & {
    refinedOptions: number[] | undefined;
};

class MetricsDropdown extends React.Component<Props> {
    disableOptions = (options, refinedOptions) => options.map(option => ({
        ...option,
        isDisabled: !(refinedOptions && refinedOptions.includes(option.value)),
    }));

    render() {
        const { refinedOptions } = this.props;

        return (
            <ChartDropdown
                {...this.props}
                label={_('filter_metric_title').toUpperCase()}
                filterKey="metric_id"
                localePrefix="metric_"
                preprocessOptions={options =>
                    refinedOptions
                        ? this.disableOptions(options, refinedOptions)
                        : options
                }
            />
        );
    }
}

export default MetricsDropdown;
